"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var withCustomError = function (validator) { return function (errorMessage) { return function () {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    var result = validator.apply(void 0, args);
    if (result !== undefined) {
        if (typeof errorMessage === 'function') {
            return errorMessage.apply(void 0, args);
        }
        if (typeof errorMessage === 'string') {
            return errorMessage;
        }
        return result;
    }
    return undefined;
}; }; };
exports.default = withCustomError;
//# sourceMappingURL=index.js.map